import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent {
  name = sessionStorage.getItem('name');
  msMeUserName = sessionStorage.getItem('msMeUserName');
  isDrop: boolean = false;
  constructor(private router: Router) { }

  toggleDrop() {
    this.isDrop = !this.isDrop;
  }

  navigatetopage() {
    sessionStorage.setItem('readonlyUsername', JSON.stringify(this.msMeUserName));
    sessionStorage.setItem('singInAs', 'MsMeUser');
    //alert("user name is "+sessionStorage.getItem('readonlyUsername'));
    this.router.navigateByUrl("/changepassword");
  }

  //navigatetoOtherDetailspage() {
  //  this.router.navigateByUrl("/otheruserdetails");
  //}

  //navigatetoProfile() {
  //  this.router.navigateByUrl("/msmeuserprofile");
  //}

  Logout() {
    sessionStorage.clear();
    this.router.navigateByUrl("");
  }
  //isMenuHidden = false;   // ✅ variable

  //toggleMenu() {         // ✅ function
  //  this.isMenuHidden = !this.isMenuHidden;
  //}
  isMenuHidden = true;   // ✅ LOGIN KE BAAD BY DEFAULT HIDE

  ngOnInit() {
    // login hone ke baad yahi rahega
    this.isMenuHidden = true;
  }

  toggleMenu() {
    this.isMenuHidden = !this.isMenuHidden; // ✅ burger click
  }
}

